import { styled } from '@fluentui/react';
import { SignUpBrandedHeader } from '../presentationalComponents/SignUpBrandedHeader';
import { getSignUpHeaderStyles } from '../styles/signUpBrandedHeaderStyles';

export const SignUpBrandedHeaderContainer = styled(SignUpBrandedHeader, getSignUpHeaderStyles);
